const updateCreditAppDeals = _ref => {
  let {
    types
  } = _ref;
  return payload => async dispatch => {
    // call reducer to merge payload with current state without duplicates
    dispatch({
      type: types.UPDATE_CREDIT_APP_DEALS,
      payload
    });
  };
};
export default updateCreditAppDeals;